export const FETCH_CHARITY_API = "CHARITY:FETCH_CHARITY_API";
export const UPDATE_CHARITY = "CHARITY:UPDATE_CHARITY";
export const FETCH_DONATION = "CHARITY:FETCH_DONATION";
export const CREATE_DONATION = "CHARITY:CREATE_DONATION";
export const UPDATE_DONATION = "CHARITY:UPDATE_DONATION";
